import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      list_all: {
        weekly: {
          leaders: [],
          topThree: [],
          otherPlayers: [],
          currentUser: null
        },
        alltime: {
          leaders: [],
          topThree: [],
          otherPlayers: [],
          currentUser: null
        },
        error: null,
        loading: true
      }
    };

    super('leaderboard', defaultState);
    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESHING, () => {
      this.state.list_all.loading = true;
      this.state.list_all.error = null;
    });

    this.on(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESHED, (data) => {
      if (data && typeof data === 'object') {
        this.state.list_all.weekly = data.weekly || this.defaultState.list_all.weekly;
        this.state.list_all.alltime = data.alltime || this.defaultState.list_all.alltime;
        this.state.list_all.loading = false;
        this.state.list_all.error = null;
      } else {
        this.state.list_all.loading = false;
        this.state.list_all.error = 'Mauvais format de donnée';
      }
    });

    this.on(constants.EVENTS.LEADERBOARD.LIST_ALL.REFRESH_ERROR, (error) => {
      this.state.list_all.loading = false;
      this.state.list_all.error = error?.message || error;
      this.state.list_all.weekly = this.defaultState.list_all.weekly;
      this.state.list_all.alltime = this.defaultState.list_all.alltime;
    });
  }
}

export default Store;
// new Store();
